import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f078d962"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-menu" }
const _hoisted_2 = { class: "app-menu__wrap" }

import EnkryptBanner from "@/components/enkrypt-banner/index.vue";
import { useRoute } from "vue-router";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();

const showLeftBanner = computed(() => {
  return (
    route.name == "send" ||
    route.name == "send-verify" ||
    route.name == "invite"
  );
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: { name: 'main' } }, {
        default: _withCtx(() => [
          _createTextVNode("Accounts")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'send' } }, {
        default: _withCtx(() => [
          _createTextVNode("Send")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'stake' } }, {
        default: _withCtx(() => [
          _createTextVNode("Stake")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'crowdloan' } }, {
        default: _withCtx(() => [
          _createTextVNode("Crowdloan")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'claim' } }, {
        default: _withCtx(() => [
          _createTextVNode("Claim DOT")
        ]),
        _: 1
      }),
      (showLeftBanner.value)
        ? (_openBlock(), _createBlock(EnkryptBanner, {
            key: 0,
            "is-left": true
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})